module.exports = __webpack_public_path__ + "img/smb-funding-1.b55dfb09.png";